import React from 'react';

const DataSourcePanel = ({ 
  showDataSources, 
  setShowDataSources, 
  dataSource, 
  GOOGLE_SCRIPT_URL,
  authorizeAndAccessScript 
}) => {
  return (
    <>
      {/* Data Source Panel - Collapsed by default */}
      <div className="bg-white border-b border-gray-200 overflow-hidden transition-all duration-300" style={{ maxHeight: showDataSources ? '300px' : '0px' }}>
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex justify-between items-center mb-4">
            <h3 className="text-lg font-medium text-gray-800">Data Sources</h3>
            <button 
              onClick={() => setShowDataSources(false)}
              className="text-gray-500 hover:text-gray-700"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="border border-gray-200 rounded-lg p-4">
              <div className="flex justify-between items-center mb-2">
                <span className="font-medium">Candidates Data</span>
                <span className={`px-2 py-1 rounded-full text-xs ${dataSource.candidates === 'Google Sheets API' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'}`}>
                  {dataSource.candidates}
                </span>
              </div>
              <button 
                onClick={() => authorizeAndAccessScript(GOOGLE_SCRIPT_URL, 'candidates')}
                className="w-full mt-2 bg-indigo-600 text-white px-3 py-2 rounded-md text-sm hover:bg-indigo-700 transition-colors"
              >
                Test Direct Access
              </button>
            </div>
            
            <div className="border border-gray-200 rounded-lg p-4">
              <div className="flex justify-between items-center mb-2">
                <span className="font-medium">NPS Data</span>
                <span className={`px-2 py-1 rounded-full text-xs ${dataSource.nps === 'Google Sheets API' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'}`}>
                  {dataSource.nps}
                </span>
              </div>
              <button 
                onClick={() => authorizeAndAccessScript(GOOGLE_SCRIPT_URL, 'nps')}
                className="w-full mt-2 bg-indigo-600 text-white px-3 py-2 rounded-md text-sm hover:bg-indigo-700 transition-colors"
              >
                Test Direct Access
              </button>
            </div>
            
            <div className="border border-gray-200 rounded-lg p-4">
              <div className="flex justify-between items-center mb-2">
                <span className="font-medium">Salary Data</span>
                <span className={`px-2 py-1 rounded-full text-xs ${dataSource.salary === 'Google Sheets API' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'}`}>
                  {dataSource.salary}
                </span>
              </div>
              <button 
                onClick={() => authorizeAndAccessScript(GOOGLE_SCRIPT_URL, 'salary')}
                className="w-full mt-2 bg-indigo-600 text-white px-3 py-2 rounded-md text-sm hover:bg-indigo-700 transition-colors"
              >
                Test Direct Access
              </button>
            </div>
          </div>
          
          <div className="mt-4 text-center">
            <button 
              onClick={() => window.location.reload()}
              className="bg-green-600 text-white px-4 py-2 rounded-md text-sm hover:bg-green-700 transition-colors inline-flex items-center"
            >
              <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
              </svg>
              Reload Dashboard
            </button>
            <span className="ml-2 text-sm text-gray-500">After updating your Google Apps Script</span>
          </div>
        </div>
      </div>
      
      {/* Data Source Toggle Button */}
      {!showDataSources && (
        <div className="max-w-7xl mx-auto px-6 py-2">
          <button 
            onClick={() => setShowDataSources(true)}
            className="text-sm text-gray-600 hover:text-indigo-600 inline-flex items-center transition-colors"
          >
            <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            Show Data Sources
          </button>
        </div>
      )}
    </>
  );
};

export default DataSourcePanel;
